// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saved-images-app-width {
    width: 1229px;
}

.thumbs-style .carousel .thumbs-wrapper {
    overflow-x: scroll;
}

.thumb {
    height: 70px;
}

.images{
    object-fit: none;
    object-position: 50%;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/mpp_app.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB","sourcesContent":[".saved-images-app-width {\n    width: 1229px;\n}\n\n.thumbs-style .carousel .thumbs-wrapper {\n    overflow-x: scroll;\n}\n\n.thumb {\n    height: 70px;\n}\n\n.images{\n    object-fit: none;\n    object-position: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
